import { Checkbox, FormControlLabel, FormGroup } from "@material-ui/core";
import { useCallback, useState } from "react";
import Fix from "../layers/Fix";
import { makeStyles } from "@material-ui/core/styles";
import flyByWptImg from "../../../images/contents/map/fix/Fly-by_WPT.png";
import triangle01Img from "../../../images/contents/map/fix/triangle_01.png";
import triangle02Img from "../../../images/contents/map/fix/triangle_02.png";

const useStyles = makeStyles((theme) => ({
  checkLabel: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 12
  }
}));


function LegendFix({contents: fix}) {
  const classes = useStyles();
  const [contentsState, setContentsState] = useState(fix.getContentsVisibleState());

  const toggleContents = useCallback(event => {
    fix.setVisible(event.target.checked, event.target.name);
    setContentsState({...contentsState, [event.target.name]:event.target.checked});
  }, [fix, contentsState]);

  return (
    <div>
    <FormGroup>
      <FormControlLabel
        control={<Checkbox checked={contentsState[Fix.FIX_NAME]} onChange={toggleContents} name={Fix.FIX_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            <img src={triangle01Img} alt="Compulsory Reporting Point"/>
            Compulsory Reporting Point
          </span>
        }
      />
      <FormControlLabel
        control={<Checkbox checked={contentsState[Fix.FIXN_NAME]} onChange={toggleContents} name={Fix.FIXN_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            <img src={triangle02Img} alt="Non-Compulsory Reporting"/>
            <span>Non-Compulsory Reporting</span>
          </span>
        }
      />
      <FormControlLabel
        control={<Checkbox checked={contentsState[Fix.RNAV_NAME]} onChange={toggleContents} name={Fix.RNAV_NAME} size='small'/>}
        label={
          <span className={classes.checkLabel}>
            <img src={flyByWptImg} alt="RNAV Waypoint"/>
            RNAV Waypoint
          </span>
        }
      />
    </FormGroup>
    </div>
  )
}

export default LegendFix;